import React from 'react';
import styles from './styles.css';

import cx from 'classnames';
import Icon from '../Icon';

type Props = {
  width?: string;
  text?: string;
  size?: string;
};

const Info: React.FC<Props> = ({ width, text, size }) => {
  return (
    <div className={cx(styles.infoTooltip)}>
      <Icon name="circle-info-blue" />
      <span
        className={cx(
          styles.tooltip,
          styles.tooltipRight,
          size && styles[size]
        )}
      >
        {text}
      </span>
    </div>
  );
};

export default Info;
